import { Theme } from '@mui/material/styles'
import { makeStyles } from 'tss-react/mui'

const BaseLayoutStyle = makeStyles()((theme: Theme) => ({
  forgetUsernameTitle: {
    color: '#4F5A65',
    fontSize: '12px',
    lineHeight: '14px',
    fontWeight: 'normal',
    fontFamily: 'Acronym-Regular',
    '& a': {
      color: '#FF4500',
    },
  },
  NotBrightMLSSubscriberTitle: {
    fontWeight: 'normal',
    fontSize: '18px',
    fontFamily: 'Acronym-Regular',
    color: '#4F5A65',
    lineHeight: '24px',
    marginBottom: 0,
    [theme.breakpoints.between(0, 600)]: {
      fontSize: '16px',
      lineHeight: '22px',
    },
  },
  joinUsTitle: {
    fontWeight: 'bold',
    fontSize: '18px',
    fontFamily: 'Acronym-Regular',
    lineHeight: '24px',
    textDecoration: 'underline',
    letterSpacing: '0.07em',
    color: '#4F5A65 !important',
    [theme.breakpoints.between(0, 600)]: {
      fontSize: '14px',
      lineHeight: '20px',
    },
  },
  SubscriberAndJoinUSBOX: {
    flexDirection: 'row',
    [theme.breakpoints.between(0, 600)]: {
      flexDirection: 'column',
      marginTop: '43px',
      marginBottom: '78px',
      borderTop: '1px solid',
      alignItems: 'center',
      borderBottom: '1px solid',
    },
  },
  JoinUSBOX: {
    [theme.breakpoints.between(0, 600)]: {
      borderTop: 'none',
      borderBottom: 'none',
      paddingBottom: '7px',
      paddingTop: '0px',
    },
  },
  JoinUS: {
    marginBottom: 0,
  },
  SubscriberBOX: {
    [theme.breakpoints.between(0, 600)]: {
      borderBottom: 'none',
      padding: theme.spacing(1.8, 0, 0.8, 0),
      borderTop: 'none',
    },
  },
  loginCheckBox: {
    marginTop: '-6px',
    '& .MuiFormControlLabel-root': {
      marginLeft: '-2px',
      '& .MuiCheckbox-colorPrimary': {
        padding: theme.spacing(0, 0.625, 0, 0),
      },
      '& .MuiTypography-body1': {
        fontSize: '14px',
        lineHeight: '16px',
        color: '#4F5A65',
      },
    },
  },
}))

export default BaseLayoutStyle
